document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.p-characteristics--more__contents');
  if (!root) return;

  // アコーディオン（続きを読む）機能
  function setupAccordion(inner) {
    const textMain = inner.querySelector('.c-text--main');
    if (!textMain) return;

    // 要素が非表示の場合は高さを正しく計算できないため、処理を中断
    if (inner.offsetParent === null) {
      return;
    }

    // 既存のボタンやフェードをリセット
    const oldBtn = inner.querySelector('.c-text--main__more-btn');
    if (oldBtn) oldBtn.remove();
    const oldFade = textMain.querySelector('.c-text--main__fade');
    if (oldFade) oldFade.remove();
    textMain.style.maxHeight = '';
    textMain.style.overflow = '';
    textMain.classList.remove('is-fade');

    // 既に開かれている場合は何もしない
    if (textMain.classList.contains('is-open')) {
      return;
    }

    // 1024px以下のみ適用
    if (window.innerWidth <= 1024) {
      const maxHeight = 70;
      if (textMain.scrollHeight > maxHeight) {
        textMain.style.maxHeight = maxHeight + 'px';
        textMain.style.overflow = 'hidden';
        textMain.classList.add('is-fade');

        // フェード用要素とボタン追加
        const fade = document.createElement('div');
        fade.className = 'c-text--main__fade';
        textMain.appendChild(fade);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'c-text--main__more-btn';
        btn.innerHTML = '続きを読む <i class="fa-solid fa-angle-down"></i>';
        textMain.after(btn);

        btn.addEventListener('click', function () {
          textMain.style.maxHeight = 'none';
          textMain.style.overflow = 'visible';
          textMain.classList.remove('is-fade');
          textMain.classList.add('is-open'); // 開いた状態をクラスで管理
          fade.style.display = 'none';
          btn.style.display = 'none';
        });
      }
    } else {
      // 1024pxより大きい場合は is-open クラスを削除してリセット
      textMain.classList.remove('is-open');
    }
  }

  // サイド・メイン切り替え
  const sideLis = root.querySelectorAll('.p-characteristics--more__contents__side ul li');
  const mainInners = root.querySelectorAll('.p-characteristics--more__contents__main__inner');
  if (sideLis.length === 0 || mainInners.length === 0) return;

  // 初期化
  sideLis.forEach(li => li.classList.remove('active'));
  mainInners.forEach(inner => {
    inner.classList.remove('active');
    inner.style.opacity = 0;
    inner.style.pointerEvents = 'none';
    inner.style.transition = 'opacity 0.4s';
    inner.style.display = 'none';
  });
  sideLis[0].classList.add('active');
  mainInners[0].classList.add('active');
  mainInners[0].style.display = '';
  setTimeout(() => {
    mainInners[0].style.opacity = 1;
    mainInners[0].style.pointerEvents = '';
    setupAccordion(mainInners[0]); // 初期表示のコンテンツに適用
  }, 10);

  sideLis.forEach((li, idx) => {
    li.addEventListener('click', function () {
      sideLis.forEach(l => l.classList.remove('active'));
      li.classList.add('active');
      mainInners.forEach((inner, i) => {
        if (i === idx) {
          inner.classList.add('active');
          inner.style.display = '';
          setTimeout(() => {
            inner.style.opacity = 1;
            inner.style.pointerEvents = '';
            setupAccordion(inner); // 表示されるコンテンツに適用
          }, 10);
        } else {
          inner.classList.remove('active');
          inner.style.opacity = 0;
          inner.style.pointerEvents = 'none';
          setTimeout(() => {
            inner.style.display = 'none';
          }, 400);
        }
      });
    });
  });

  // リサイズ時も対応
  window.addEventListener('resize', function () {
    mainInners.forEach(inner => {
      setupAccordion(inner);
    });
  });
});
